import { api } from "lib"

export const getTimePlanShiftByCompany = async (params) => {
    return await api.post("/v1/timePlanShift/getTimePlanShiftByCompany", params)
}
export const getDepartmentOptions = async (params = {}) => {
    return await api.post("/v1/dropdown/getStmDepartment", params);
};
export const getPositionOptions = async (params = {}) => {
    return await api.post("/v1/dropdown/getPosition", params);
};

export const getAttendanceSettingShift = async (params) => {
    return await api.post(
        "/v1/dropdown/getAttendanceSettingShift",
        params
    );
};

export const getSubOrdinates = async (params = {}) => {
    return await api.post("/v1/supervisorManagement/getSubOrdinates", params);
};